module.exports = __webpack_public_path__ + "static/media/chromoskyn_5.2266ef0b.gif";